import React from "react";

export const SvgReviewReplyIcon = () => {
	return (
		<svg
			xmlns="http://www.w3.org/2000/svg"
			width="48"
			height="48"
			viewBox="0 0 48 48"
		>
			<g
				id="Group_1645"
				data-name="Group 1645"
				transform="translate(-74.609 -12.501)"
			>
				<g
					id="Rectangle_2041"
					data-name="Rectangle 2041"
					transform="translate(74.609 12.501)"
					fill="none"
					stroke="#fba919"
					strokeWidth="1.5"
				>
					<rect width="48" height="48" rx="23" stroke="none" />
					<rect
						x="0.75"
						y="0.75"
						width="46.5"
						height="46.5"
						rx="22.25"
						fill="none"
					/>
				</g>
				<g
					id="SS_Logo_svg"
					data-name="SS Logo svg"
					transform="translate(82.827 21.908)"
				>
					<path
						id="Path_5895"
						data-name="Path 5895"
						d="M107,68.787l.6,1.688s6.669-4.154,9.052-5.626c3.144-2.73.414-7.083-2.565-7.05a3.9,3.9,0,0,0-3.541,2.035c-1.142,1.837-.083,4.468.927,4.981.132-.083,1.158-.827,1.456-1.026-1.522-.927-1.853-3.972,1.026-4.269,2.267-.083,2.929,2.946,1.655,4C115.191,63.773,107,68.787,107,68.787Z"
						transform="translate(-98.153 -57.799)"
						fill="#fba919"
					/>
					<path
						id="Path_5896"
						data-name="Path 5896"
						d="M154.8,105.688l1.605-.943s6.487,4.832,7.414,5.329a2.193,2.193,0,0,0,3.359-1.671c.132-3.111-4.1-3.028-4.5-.6-.645-.447-.778-.6-1.423-1.043.86-2.631,4.071-3,5.726-2.118a3.782,3.782,0,0,1,2,3.74c-.364,3.409-3.74,4.733-5.891,3.31C161.982,110.933,154.8,105.688,154.8,105.688Z"
						transform="translate(-138.043 -96.536)"
						fill="#fba919"
					/>
					<path
						id="Path_5897"
						data-name="Path 5897"
						d="M166.564,142.3l1.423,1.059s-3.095,8.556-3.21,8.936a2.3,2.3,0,1,0,2.019-1.721c.331-.976.414-1.125.629-1.671a4.181,4.181,0,0,1,3.591,4.452,4.271,4.271,0,0,1-3.872,3.475,4.017,4.017,0,0,1-4.021-4.865C163.453,151.038,166.564,142.3,166.564,142.3Z"
						transform="translate(-144.925 -128.317)"
						fill="#fba919"
					/>
					<path
						id="Path_5898"
						data-name="Path 5898"
						d="M90.9,185.453l.645-1.853s-9.085.017-10.409.017a3.994,3.994,0,0,0-3.707,5.113c1.986,5.428,9,2.3,7.645-2.184-.579-.017-1.522-.033-1.787-.033a2.32,2.32,0,0,1-2.019,3.277,2.2,2.2,0,0,1-.364-4.369C81.5,185.437,90.9,185.453,90.9,185.453Z"
						transform="translate(-73.363 -162.782)"
						fill="#fba919"
					/>
					<path
						id="Path_5899"
						data-name="Path 5899"
						d="M62.353,116.582h1.9s-2.879-9.052-3.028-9.565a3.932,3.932,0,0,0-7.612,1.936,3.793,3.793,0,0,0,5.875,2.714c-.248-.894-.348-1.274-.5-1.82a2.233,2.233,0,0,1-3.79-1.7,2.264,2.264,0,0,1,4.269-.761C59.655,107.927,62.353,116.582,62.353,116.582Z"
						transform="translate(-53.539 -96.558)"
						fill="#fba919"
					/>
				</g>
			</g>
		</svg>
	);
};
